import { ActivatedRoute, Router } from '@angular/router';
import {
  AppDataService,
  AvailableDocument,
  DocumentService,
  FormBuildService,
  GetCorePageDataService,
  GlobalVariablesService,
  StepRequest,
  StepsService,
  AutoDeclineRequest
} from '@tmhcc-ng-lib/data-service';
import { has, isNullUndefinedEmptyOrWhiteSpace } from '@tmhcc/util';
import { FormGroup } from '@angular/forms';
import {
  UCMBackEventName,
  ProductType,
  UcmUrl,
  DocumentAPIPath,
  SubmissionType,
  UCMEventName,
  ProductsNavRoutes,
  PolicyStatus,
  GeneralPageName
} from '@tmhcc-ng-lib/models';
import {
  DialogConfig,
  DialogService,
  DialogSize
} from '@tmhcc-ng-lib/framwork/dialog';
import { IsTrue } from 'libs/util/binary-util';
import { UCMSharedService } from './ucm-shared.service';
import { LoaderService } from '@tmhcc-ng-lib/framwork/loader';
import { DownloadDocumentRequest } from 'libs/data-service/def/document';
import { AutoDeclineService } from '../common-liability/auto-decline/auto-decline.service';
import { AccordionService } from '../accordion-menu/accordion.service';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { CustomModalComponent } from 'libs/artisan-edge/src/lib/custom-modal/custom-modal.component';
import { Directive } from "@angular/core";

@Directive()
export class BaseUCMFormsComponent {
  public ucmFormGroup: FormGroup;
  public isFormRendered = false;
  public pageSettings = {
    pageName: ''
  };
  public formJson: any;
  public elementDefaults: any = {};
  public ucmSLFormId: number;
  errMessage: string =
    'You are able to be taken to the fully editable renewal application from A new application will be generated which must be signed prior to be binding.Are you sure you want to do this?';
  modalTitle: string = 'EDIT POLICY INFORMATION';
  modalContent: DialogConfig = {
    data: {
      para: '',
      footerBtnLabel: '',
      showFooterBtn: true
    },
    modalSetting: {
      title: '',
      hideHeader: false,
      hideFooter: true,
      hideHeaderX: false,
      hideSave: true,
      closeOnOutsideClick: true
    }
  };
  showDebugConsoleMessages = 'false';

  constructor(
    protected router: Router,
    protected globalVariables: GlobalVariablesService,
    protected getSiteCoreDataService: GetCorePageDataService,
    protected ucmService: UCMSharedService,
    protected formBuildService: FormBuildService,
    protected loaderService: LoaderService,
    protected activeRouter: ActivatedRoute,
    protected documentService: DocumentService,
    protected appDataService: AppDataService,
    protected autoDeclineService: AutoDeclineService,
    protected stepsService: StepsService,
    protected accordionService: AccordionService,
    protected configService: AppConfigService
  ) { }

  ngOnInit(): void {
    if (this.configService.config.logging.console) {
      this.showDebugConsoleMessages = 'true';
    }
    this.globalVariables.policyStatus = '';
    this.activeRouter.params.subscribe(params => {
      this.pageSettings.pageName = params['id'];

      this.updatedPolicy();
    });
  }
  updatedPolicy() {
    let payload: StepRequest = {
      policyId: this.globalVariables.policyId,
      versionNum: this.globalVariables.policyVersionId
    };

    if (this.globalVariables.policyId && this.globalVariables.policyId > 0) {
      this.stepsService.getPolicyDetails(payload).subscribe(res => {
        this.loaderService.hide();
        if (res) {
          this.appDataService.updatePolicyDetails(res);

          this.globalVariables.showSubmitButton = !res.UnderwritingDocumentsRequired;

          this.elementDefaults.showSubmitButton = IsTrue(
            this.globalVariables.showSubmitButton
          );

          this.accordionService.hideDocumentSubmenu(
            IsTrue(this.globalVariables.showSubmitButton)
          );
          this.globalVariables.cachedState = res.CachedState;

          //to resolve browser back page 
          if (res.SummaryDetails?.SummaryBoundItem?.PolicyStatus &&
            res.SummaryDetails?.SummaryBoundItem?.PolicyStatus == PolicyStatus.DeclinedNB
          ) {
            let prodType = this.globalVariables.productName;
            let submissionType = SubmissionType[prodType];
            if (this.router.url != submissionType[GeneralPageName.Declined]) {
              this.redirectTo(submissionType[GeneralPageName.Declined]);
            }
          }
          else if (res.SummaryDetails?.SummaryBoundItem?.PolicyStatus &&
            res.SummaryDetails?.SummaryBoundItem?.PolicyStatus == PolicyStatus.PendingUWReview
          ) {
            let prodType = this.globalVariables.productName;
            let submissionType = SubmissionType[prodType];
            if (this.router.url != submissionType[GeneralPageName.PendingUWReview]) {
              this.redirectTo(submissionType[GeneralPageName.PendingUWReview]);
            }
          }
          else {
            this.loadUCMPage();
          }
        }
      });
    } else {
      this.loadUCMPage();
    }
  }

  loadUCMPage() {
    this.loaderService.show();
    this.isFormRendered = false;
    let pageName;
    switch (this.globalVariables.productName) {
      case ProductType.General:
        pageName = UcmUrl.General;
        break;
      case ProductType.Pollution:
        pageName = UcmUrl.Pollution;
        break;
      case ProductType.Professional:
        pageName = UcmUrl.Professional;
        break;
      case ProductType.Builders:
        pageName = UcmUrl.Builders;
        break;
      case ProductType.Excess:
        pageName = UcmUrl.Excess;
        break;
      case ProductType.Contractors:
        pageName = UcmUrl.Contractors;
        break;
      default:
        pageName = UcmUrl.General;
    }
    this.getSiteCoreDataService
      .getSiteCoreData(pageName)
      .subscribe(ucmDetails => {
        if (has(ucmDetails, 'UCMforms')) {
          let formId = this.ucmService.getUCMPageId(
            ucmDetails.UCMforms,
            this.pageSettings.pageName
          );
          this.renderUCM(formId);
        }
      });
    window.scrollTo(0, 0);
  }
  renderUCM(formID) {
    this.formBuildService.getForm(formID).subscribe(data => {
      this.formJson = data;
      setTimeout(() => {
        this.isFormRendered = true;
        this.loaderService.hide();
      }, 1000);
    });
  }

  onFormEvent(event) {
    if (has(event, 'eventParameters') && event.eventParameters.length > 0) {
      const dirtyObject = event.eventParameters.find(
        item => item.parameterName === 'IsDirty'
      );
      if (dirtyObject && IsTrue(dirtyObject.parameterValue)) {
        this.ucmFormGroup.markAsDirty();
      } else if (dirtyObject && !IsTrue(dirtyObject.parameterValue)) {
        this.ucmFormGroup.markAsPristine();
      }

      const policyNum = event.eventParameters.find(
        item => item.parameterName === 'policyNum'
      );

      if (has(policyNum, 'parameterValue')) {
        this.globalVariables.policyNum = policyNum.parameterValue;
        this.globalVariables.policyId = policyNum.parameterValue.split('-')[0];
        this.globalVariables.policyTxnNum = this.globalVariables.policyVersionId =
          policyNum.parameterValue.split('-')[1] || 0;
      }
    }
    if (event.eventName === UCMEventName.DownloadQuoteClicked) {
      this.downloadQuoteDetails();
    }

    if (event.eventName === UCMEventName.DownloadProposalDocumentEvent) {
      this.downloadQuoteProposal();
    }

    if (
      event.eventName === UCMEventName.PreviewForm ||
      event.eventName === UCMEventName.DownloadAndSign
    ) {
      this.previewSLFile();
    }
    if (event.eventName === UCMEventName.StartActivityIndicator) {
      this.loaderService.show();
    }
    if (event.eventName === UCMEventName.StopActivityIndicator) {
      this.loaderService.hide();
    }
    // if(event.eventName == UCMEventName.StartActivityDeclineVP){
    //   this.autoDeclineProcess(this.ucmFormGroup, event, true);
    // }
    if (event.eventName === UCMEventName.StartActivityDeclineSave ||
      event.eventName === UCMEventName.StartActivityDeclineNext
    ) {
      let payload: AutoDeclineRequest = {
        DeclineReasons: ['Address Change'],
        DeclinationCode: 'C1',
        AutoDecline: true,
        PolicyId: this.globalVariables.policyId,
        VersionNumber: this.globalVariables.policyTxnNum,
        PolicyTxnId: this.globalVariables.policyTxnId,
        PolicyTotal: 0,
        PolicyTypeId: this.globalVariables.policyTypeId
      };
      this.autoDeclineService.declinePolicy(payload, this.ucmFormGroup);
      event.eventName = 'Declined';
      event.policyId = this.globalVariables.policyId;
      event.policyTxnNum = this.globalVariables.policyTxnNum;
      event.policyStatus = 'Declined';
      this.nevigateThroughEvent(event);
    }
    if (
      event.eventName === UCMEventName.SaveAndContinueClickedEvent ||
      event.eventName === UCMEventName.SaveAndContinueClicked
    ) {
      this.autoDeclineProcess(this.ucmFormGroup, event, true);
    }
    if (event.eventName === UCMEventName.RenewalContinueClicked) {
      this.autoDeclineProcess(this.ucmFormGroup, event, true);
    }
    if (event.eventName === UCMEventName.SaveClicked) {
      this.updatedPolicy();
    }
    if (event.eventName === UCMEventName.Step1NextClicked &&
      (this.globalVariables.subCompanyCode == "CUI" ||
        this.globalVariables.subCompanyCode == "AXL")
    ) {
      this.autoDeclineProcess(this.ucmFormGroup, event, false);
    }
    if (
      event.eventName === UCMEventName.Step1CNextClicked ||
      event.eventName === UCMEventName.Step2ANextClicked ||
      event.eventName === UCMEventName.Step2BNextClicked ||
      event.eventName === UCMEventName.Step2CNextClicked ||
      (event.eventName === UCMEventName.Step3ANextClicked
        && this.globalVariables.subCompanyCode != "ARC" && this.globalVariables.subCompanyCode != "AXL") ||
      event.eventName === UCMEventName.Step3BNextClicked ||
      event.eventName === UCMEventName.Step2DNextClicked
    ) {
      this.autoDeclineProcess(this.ucmFormGroup, event, false);
    }
    else if (event.eventName === UCMEventName.Step3ASubmitClicked && this.globalVariables.subCompanyCode != "ARC" && this.globalVariables.subCompanyCode != "AXL") {
      this.autoDeclineProcess(this.ucmFormGroup, event, true);
    }
    else if (event.eventName === UCMEventName.Step3BSubmitClicked) {
      this.autoDeclineProcess(this.ucmFormGroup, event, true);
    } else if (event.eventName === UCMEventName.APIResultEvent) {
      const summaryData = event.eventParameters.find(
        item => item.parameterName === 'apiresult'
      );
      if (has(summaryData, 'parameterValue')) {
        if (!isNullUndefinedEmptyOrWhiteSpace(summaryData.parameterValue)) {
          let data = JSON.parse(summaryData.parameterValue);
          this.appDataService.updatePolicyDetails(data);
        }
      }
    } else {
      this.nevigateThroughEvent(event);
    }
  }
  previewSLFile() {
    let payload: DownloadDocumentRequest = {
      policyId: this.globalVariables.policyId,
      versionNum: this.globalVariables.policyVersionId,
      ucmFormId: this.ucmSLFormId
    };
    this.loaderService.show();
    this.documentService.previewSLApplication(payload).subscribe(base64 => {
      this.documentService.openBase64NewTab(base64.Pdf);
      this.refreshPolicyDetails();
    });
  }
  refreshPolicyDetails() {
    let payload: StepRequest = {
      policyId: this.globalVariables.policyId,
      versionNum: this.globalVariables.policyVersionId
    };
    this.appDataService.fetchAndPublishPolicyDetails(payload);
    this.appDataService.fetchAndPublishDocumentsDetail(payload);
  }
  downloadQuoteDetails() {
    let payload: DownloadDocumentRequest = {
      policyId: this.globalVariables.policyId,
      versionNum: this.globalVariables.policyVersionId
    };
    this.loaderService.show();
    this.documentService.downloadQuote(payload).subscribe(pdfData => {
      if (has(pdfData, 'Pdf')) {
        this.ucmFormGroup.markAsPristine();
        this.documentService.openBase64NewTab(pdfData.Pdf);
        this.loaderService.hide();
      }
    });
  }

  downloadQuoteProposal() {
    let payload: DownloadDocumentRequest = {
      policyId: this.globalVariables.policyId,
      versionNum: this.globalVariables.policyVersionId
    };
    this.loaderService.show();
    this.documentService
      .downloadQuoteProposalDocument(payload)
      .subscribe(pdfData => {
        if (has(pdfData, 'Pdf')) {
          //this.ucmFormGroup.markAsPristine();
          this.documentService.openBase64NewTab(pdfData.Pdf);
          this.loaderService.hide();
        }
      });
  }

  nevigateThroughEvent(event: any) {
    let prodType = this.globalVariables.productName;
    let submissionType = SubmissionType[prodType];

    const stepNevigation = event.eventParameters.find(
      item => item.parameterName === 'activityLog'
    );
    if (
      has(stepNevigation, 'parameterValue') &&
      stepNevigation.parameterValue != 'NotFound' &&
      stepNevigation.parameterValue != 'null' &&
      stepNevigation.parameterValue != ''
    ) {
      let indexOfEventName: any = UCMBackEventName[event.eventName];
      if (!indexOfEventName || indexOfEventName < 1) {
        this.ucmFormGroup.markAsPristine();
      }
      this.redirectTo(submissionType[stepNevigation.parameterValue]);
    }
  }
  redirectTo(uri) {
    this.router.navigate([uri]);
  }
  setElementDefault() {
    this.elementDefaults.policyProducerContactId = this.globalVariables.agencyId;
    if (
      !isNullUndefinedEmptyOrWhiteSpace(this.globalVariables.policyNum) &&
      this.globalVariables.policyNum != '0'
    ) {
      this.elementDefaults.policyMaster = this.globalVariables.policyNum;
    }
    this.elementDefaults.agentContactId = this.globalVariables.agentId;

    const path = this.router.url;
    let prodType = this.globalVariables.productName;
    let productRoute = ProductsNavRoutes[prodType];
    if (path.includes(productRoute.Insured)) {
      this.elementDefaults.policyTypeId = this.globalVariables.policyTypeId;
    }

    this.elementDefaults.performPolicyTypeValidation = IsTrue(
      this.globalVariables.performPolicyTypeValidation
    );

    this.elementDefaults.showSubmitButton = IsTrue(
      this.globalVariables.showSubmitButton
    );
    this.accordionService.hideDocumentSubmenu(
      IsTrue(this.globalVariables.showSubmitButton)
    );

    this.elementDefaults.businessRulesBaseURL = this.configService.config.businessRulesBaseURL;

    this.elementDefaults[
      '*ExtraHeader*-session-id'
    ] = this.globalVariables.sessionId;

  }

  // checkIfDocumentRequired(event) {
  //   this.loaderService.show();
  //   let payload: StepRequest = {
  //     policyId: this.globalVariables.policyId,
  //     versionNum: this.globalVariables.policyVersionId
  //   };
  //   this.stepsService.getPolicyDetails(payload).subscribe(res => {
  //     this.loaderService.hide();
  //     if (res) {
  //       this.globalVariables.showSubmitButton = !res.UnderwritingDocumentsRequired;
  //       this.accordionService.hideDocumentSubmenu(
  //         IsTrue(this.globalVariables.showSubmitButton)
  //       );
  //       if (!this.globalVariables.showSubmitButton) {
  //       } else {
  //         this.nevigateThroughEvent(event);
  //       }
  //     }
  //   });
  // }

  autoDeclineProcess(
    formGroup: FormGroup,
    ucmEvent: any,
    isReferralAllowed: boolean
  ) {
    this.loaderService.show();
    let payload: StepRequest = {
      policyId: this.globalVariables.policyId,
      versionNum: this.globalVariables.policyVersionId
    };
    this.stepsService.checkAutoDecline(payload).subscribe(res => {
      if (this.globalVariables.productName == ProductType.General && ucmEvent.eventName === UCMEventName.Step1CNextClicked) {
        this.elementDefaults.policyMaster = res.PolicyId + "-" + res.VersionNumber;
        this.globalVariables.policyNum = res.PolicyId + "-" + res.VersionNumber;
        this.globalVariables.policyId = res.PolicyId;
        this.globalVariables.policyVersionId = res.VersionNumber;
      }

      let payload: AutoDeclineRequest = {
        DeclineReasons: res.DeclineReasons,
        DeclinationCode: res.DeclinationCode,
        AutoDecline: res.AutoDecline,
        PolicyId: res.PolicyId,
        VersionNumber: res.VersionNumber,
        PolicyTxnId: res.PolicyTxnId,
        PolicyTotal: res.PolicyTotal,
        PolicyTypeId: res.PolicyTypeId
      };
      if (IsTrue(res.AutoDecline)) {
        this.autoDeclineService.declinePolicy(payload, formGroup);
      } else if (isReferralAllowed) {
        this.autoDeclineService.referralPolicy(formGroup);
        // } else if (ucmEvent.eventName === UCMEventName.Step3ANextClicked || ucmEvent.eventName === UCMEventName.Step2ANextClicked) {
        //   this.checkIfDocumentRequired(ucmEvent);
      } else {
        this.nevigateThroughEvent(ucmEvent);
      }
    });
  }
}
